var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-table',{attrs:{"table-header":_vm.tugPerformanceHeaders,"table-data":_vm.tugPerformanceData,"body-height":"100vh"}})}
var staticRenderFns = []

export { render, staticRenderFns }